import { EEventType } from '../../types/events';
import { EActiveView } from '../../types/view';
import { ESentEmailType } from '../../types/sentEmail';
import { EAuthenticateStatus, EAuthenticateError } from '../../types/social';
import { SOCIAL_AUTHENTICATE_TYPE } from '../../constants/action_types';
import { jsonpRequest } from '../../../browser/utils/jsonpRequest';
import { changeView } from '../view';
import { trackAuthenticateSuccess, trackRegistrationSuccess } from '../../utils/tracking';
import { fetchValidate } from '../../repositories/social-users/v1/validate';
export function authenticate(parameters) {
  var socialType = parameters.socialType,
    socialLoginId = parameters.socialLoginId,
    email = parameters.email,
    token = parameters.token,
    userCreated = parameters.userCreated,
    source = parameters.source;
  return function (dispatch, _getState, context) {
    dispatch({
      type: SOCIAL_AUTHENTICATE_TYPE,
      status: EAuthenticateStatus.Loading
    });
    fetchValidate({
      httpApi: context.httpApi,
      parameters: {
        socialLoginId: socialLoginId,
        email: email,
        token: token
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
          withCredentials: true
        }
      }
    }).then(function (response) {
      if (response.statusCode === 200) {
        var login = response.response.login;
        var logOnInfo = response.response.logOnInfo || [];
        Promise.all(logOnInfo.map(function (info) {
          return jsonpRequest("".concat(info.logOnUrl, "?") + "login=".concat(encodeURIComponent(login), "&") + "token=".concat(info.token));
        })).then(function () {
          dispatch({
            status: EAuthenticateStatus.Succeed,
            type: SOCIAL_AUTHENTICATE_TYPE
          });
          if (userCreated) {
            dispatch(changeView(EActiveView.EmailSent, {
              type: ESentEmailType.Registration,
              email: email
            }));
          }
          context.emitter.emit(EEventType.SocialAuthenticateSucceed, {
            socialType: socialType,
            isNewUser: userCreated || false
          });

          //track success
          if (userCreated) {
            trackRegistrationSuccess({
              socialType: socialType,
              source: source
            });
          } else {
            trackAuthenticateSuccess({
              socialType: socialType,
              source: source
            });
          }
        }).catch(function () {
          dispatch({
            type: SOCIAL_AUTHENTICATE_TYPE,
            status: EAuthenticateStatus.Failed,
            errorType: EAuthenticateError.Unexpected,
            error: 'Произошла непредвиденная ошибка'
          });
        });
        return;
      }
      var error = response.response.errors.length > 0 ? response.response.errors[0].message : response.response.message;
      dispatch({
        type: SOCIAL_AUTHENTICATE_TYPE,
        status: EAuthenticateStatus.Failed,
        errorType: EAuthenticateError.Common,
        error: error
      });
    }).catch(function (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.socialAuthenticate',
        socialType: socialType
      });
      dispatch({
        type: SOCIAL_AUTHENTICATE_TYPE,
        status: EAuthenticateStatus.Failed,
        errorType: EAuthenticateError.Unexpected,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function authenticateError(_type) {
  return function (dispatch) {
    dispatch({
      type: SOCIAL_AUTHENTICATE_TYPE,
      status: EAuthenticateStatus.Failed,
      errorType: EAuthenticateError.Unexpected,
      error: 'Произошла непредвиденная ошибка'
    });
  };
}
export function authenticateEmailTaken(parameters) {
  var email = parameters.email,
    socialType = parameters.socialType,
    socialLoginId = parameters.socialLoginId;
  return function (dispatch, _getState, context) {
    dispatch({
      type: SOCIAL_AUTHENTICATE_TYPE,
      status: EAuthenticateStatus.Failed,
      errorType: EAuthenticateError.EmailTaken,
      error: 'Необходимо объединить аккаунты',
      email: email,
      socialType: socialType,
      socialLoginId: socialLoginId
    });
    dispatch(changeView(EActiveView.SocialMerge));
    context.emitter.emit(EEventType.SocialAuthenticateEmailTaken, {
      type: socialType
    });
  };
}
export function authenticateEmailRequired(parameters) {
  var socialType = parameters.socialType,
    socialLoginId = parameters.socialLoginId,
    email = parameters.email,
    phone = parameters.phone;
  return function (dispatch, _getState, context) {
    dispatch({
      type: SOCIAL_AUTHENTICATE_TYPE,
      status: EAuthenticateStatus.Failed,
      errorType: EAuthenticateError.EmailRequired,
      error: 'Необходимо указать email',
      socialType: socialType,
      socialLoginId: socialLoginId,
      email: email,
      phone: phone
    });
    dispatch(changeView(EActiveView.SocialCreate));
    context.emitter.emit(EEventType.SocialAuthenticateEmailRequired, {
      type: socialType
    });
  };
}